import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path
        // fill="#7F8B91"
        stroke="#636A6E"
        d="M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334Z"
      />
      <path
        stroke="#DDD6D6"
        d="m6.5 5.333 1.667 2 1.666-2M6.167 9.333h4M6.167 7.333h4M8.167 7.333v4"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
